export default __webpack_public_path__ + "static/img-triple-crown-point-third-8de161337ea10ea4384efa8a7ebc3ffa.png";